import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../api/api';

const auth = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export default function AssignManagerModal({
  open,
  onClose,
  onSaved,
  employees = [],
}) {
  const [employeeId, setEmployeeId] = useState('');
  const [primaryId, setPrimaryId] = useState('');
  const [dottedId, setDottedId] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setEmployeeId('');
    setPrimaryId('');
    setDottedId('');
    setError(null);
  }, [open]);

  useEffect(() => {
    if (!employeeId) {
      setPrimaryId('');
      setDottedId('');
      return;
    }
    const e = employees.find((x) => String(x.id) === String(employeeId));
    setPrimaryId(e?.primary_manager_id ? String(e.primary_manager_id) : '');
    setDottedId(e?.dotted_manager_id ? String(e.dotted_manager_id) : '');
  }, [employeeId, employees]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!employeeId) {
      setError('Please pick an employee.');
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${API_URL}/api/org-chart/assign-manager`,
        {
          employee_id: Number(employeeId),
          primary_manager_id: primaryId ? Number(primaryId) : null,
          dotted_manager_id: dottedId ? Number(dottedId) : null,
        },
        auth()
      );
      onSaved?.();
    } catch (err) {
      if (err?.response?.status === 401) {
        localStorage.clear();
        window.location.assign('/login');
        return;
      }
      setError(err?.response?.data?.error || err.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  const managerOptions = employees.filter(
    (e) => String(e.id) !== String(employeeId)
  );

  return (
    <div className="org-modal-backdrop" onClick={onClose}>
      <div className="org-modal" onClick={(e) => e.stopPropagation()}>
        <h4>Assign Manager</h4>
        <p className="org-modal-sub">
          Set the primary (solid line) and optional dotted-line manager for an
          employee.
        </p>

        {error && <div className="org-modal-error">{error}</div>}

        <form onSubmit={submit}>
          <div className="form-row">
            <label>Employee</label>
            <select
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              required
            >
              <option value="">Select employee…</option>
              {employees.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name} {e.designation ? `· ${e.designation}` : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <label>Primary Manager</label>
            <select
              value={primaryId}
              onChange={(e) => setPrimaryId(e.target.value)}
            >
              <option value="">No manager (root)</option>
              {managerOptions.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name} {e.designation ? `· ${e.designation}` : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <label>Dotted-line Manager (optional)</label>
            <select
              value={dottedId}
              onChange={(e) => setDottedId(e.target.value)}
            >
              <option value="">None</option>
              {managerOptions.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name} {e.designation ? `· ${e.designation}` : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="org-modal-foot">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
